const rootUrl = process.env.REACT_APP_API_URL;
export const GROUPS_URL = `${rootUrl}groups/`;
export const PRODUCTS_URL = `${rootUrl}products/`;
export const PRICES_URL = `${rootUrl}prices/`;
export const FEATURED_PRODUCTS_URL = `${rootUrl}products/featured/`;
export const RECOMMENDED_PRODUCTS_URL = `${rootUrl}products/recommended/`;
export const RELATED_PRODUCTS_URL = `${rootUrl}products/related/`;
export const SEARCH_PRODUCTS_URL = `${rootUrl}products/search/:searchTerm`;
export const GROUP_PRODUCTS_URL = `${rootUrl}groups/:id/products/`;
export const SETTINGS_URL = `${rootUrl}suppliers/settings/`;
export const SITE_LINKS_URL = `${rootUrl}sitelinks/`;
export const REPRESENTATIVES_URL = `${rootUrl}Representatives/search/`;

export const VARIATIONS_URL = `${rootUrl}variations/filter/`;
export const LOGIN_URL = `${rootUrl}account/login/`;
export const REGISTER_URL = `${rootUrl}account/register/`;
export const SAVE_PROFILE_URL = `${rootUrl}account/saveProfile/`;

export const CHECK_CUSTOMER_EXISTS_URL = `${rootUrl}account/CheckExists/`;
export const LOGOUT_URL = `${rootUrl}account/logout/`;
export const FORGOT_PASSWORD_URL = `${rootUrl}account/forgotPassword/`; 
export const CHECK_SESSION_URL = `${rootUrl}account/check/`;
export const PROMOTIONS_URL = `${rootUrl}promotions/`;
export const SLIDER_URL = `${rootUrl}Slider/`;
export const NEWSLETTER_SUBSCRIBE_URL = `${rootUrl}Newsletter/Subscribe/`;

export const ORDER_URL = `${rootUrl}orders/`;
export const ORDER_CHECKOUT_URL = `${ORDER_URL}checkout/`;
export const ORDER_DETAILS_URL = `${ORDER_URL}:id`; 
export const CUSTOMER_ORDERS_URL = `${rootUrl}customers/:customerId/orders`;

export const PAYMENTS_URL = `${rootUrl}Payment/`;
export const AUTHORIZE_PAYMENTS_URL = `${rootUrl}Payment/AuthorizePaymentAsync`;
export const GetStripePaymentLink_URL = `${rootUrl}PaymentStripeLink/GetStripePaymentLink`;

export const PAGES_URL = `${rootUrl}Pages/`;

export const CONTACT_REP_URL = `${rootUrl}Notifications/contactrep/`;
export const SHARE_BY_EMAIL_URL = `${rootUrl}Notifications/ShareByEmail/`;

export const OPENPAY_URL = `${rootUrl}openpay/`;
export const OPENPAY_CREATE_URL = `${OPENPAY_URL}create/`;
export const OPENPAY_GET_STATUS_URL = `${OPENPAY_URL}status/:openpayOrderId`;
export const OPENPAY_LOG_CALLBACK_URL = `${rootUrl}Log/add`;


export const GET_CARTS_URL = `${rootUrl}carts/`;
export const SAVE_CART_URL = `${rootUrl}carts/`;
export const REMOVE_CART_URL = `${rootUrl}carts/`;

export const GET_TRANSLATIONS_URL = `${rootUrl}translations/`;


export const GET_CUSTOMER_REFERRALS_URL = `${rootUrl}Referrals/GetCustomerReferrals/:customerId`;
export const GET_ACTIVE_REFERRAL_PROGRAM_SETTING_URL = `${rootUrl}Referrals/GetActiveReferralProgramSetting`;
export const GET_CUSTOMER_REFERRAL_CODE = `${rootUrl}Referrals/GetCustomerReferralCode/:customerId`;
export const CREATE_CUSTOMER_REFERRAL_CODE = `${rootUrl}Referrals/CreateCustomerReferralCode/:customerId`;

export const Representatives_GetByLocation = `${rootUrl}Representatives/GetByLocation`